<template>
    <v-flex>
        <v-card>
            <v-card-title primary-title>
                <h3 class="headline mb-0">All Groups</h3>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="$store.state.searchPhrase"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="getGroupList"
                    :search="$store.state.searchPhrase"
                    :rows-per-page-items="rowsPerPage"
            >
                <template slot="items" slot-scope="props">
                    <td class="subheading" @click="routeLink(props.item.id)">{{ props.item.name }}</td>
                    <td class="subheading" @click="routeLink(props.item.id)">{{ props.item.devices.length }}</td>
                    <td class="subheading" @click="routeLink(props.item.id)">{{ props.item.users.length }}</td>
                    <td class="subheading">
                        <v-btn flat icon color="blue" @click="routeLink(props.item.id)">
                            <v-icon>info</v-icon>
                        </v-btn>
                        <v-btn flat icon color="indigo" @click="deleteGroup(props.item.id)"
                               v-if="props.item.devices.length === 0">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>


        <v-dialog v-model="deleteDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Delete This Group?</v-card-title>
                <v-card-text>Please confirm that you want to delete this group. Note that this action cannot be
                    undone.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="startDeleteGroup">Yes, delete</v-btn>
                    <v-btn color="green darken-1" flat @click.native="deleteDialog = false">No, cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "GroupsList",
        data() {
            return {
                search: '',
                deleteDialog: false,
                deleteSelected: '',
                rowsPerPage: [25, 50, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                headers: [
                    {text: 'Group Name', align: 'left', sortable: true, value: 'name'},
                    {text: '# Devices', align: 'left', sortable: true, value: 'devices'},
                    {text: 'Users', align: 'left', sortable: true, value: 'users'},
                    {text: 'Actions', align: 'left', sortable: false}
                ]
            }
        },
        computed: {
            ...mapGetters(['getGroupList'])
        },
        methods: {
            ...mapActions(['removeGroup']),
            routeLink: function (val) {
                this.$router.push('/group/' + val)
            },
            deleteGroup: function (val) {
                this.deleteSelected = val
                this.deleteDialog = true
            },
            startDeleteGroup: function () {
                this.deleteDialog = false
                if (this.deleteSelected !== '' && this.deleteSelected !== undefined) {
                    this.removeGroup(this.deleteSelected)
                }
            }
        }
    }
</script>

<style scoped>

</style>
